module.exports = __webpack_public_path__ + "static/media/no-connection-gray.0c5617f2.svg";